import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="warning"
      title="Payment Cancelled"
      subTitle="Your payment was not completed. No charges were made."
      extra={[
    
        <Button
          key="courses"
          onClick={() => navigate("/selfLearner-dashboard/available-courses")}
        >
          Browse Courses
        </Button>,
      ]}
    />
  );
};

export default PaymentCancel;
